export interface ReadOnlyFieldProps {
  label: string;
  value: string | null | undefined;
  wide?: boolean;
}

export default function ReadOnlyField({ label, value, wide = false }: ReadOnlyFieldProps) {
  return (
    <div className={`sendin-input sendin-input-readonly ${wide ? "sendin-field-wide" : ""}`}>
      <span className="sendin-field-label">{label}</span>
      <strong>{value || "—"}</strong>
    </div>
  );
}
